import { useQuery } from '@tanstack/vue-query'

export const RESTAURANTS_CACHE_KEYS = {
  bySlug(slug: string) {
    return [`restaurant`, slug]
  },
  bySearchQuery(query: MaybeRef<string>) {
    return ['restaurants/search', query]
  },
  events(slug: string) {
    return ['restaurant-events', slug]
  },
}

export function useGetRestaurantBySlug(slug: string) {
  const { $orpc } = useNuxtApp()
  const { locale } = useI18n()

  return useQuery({
    queryKey: computed(() => [...RESTAURANTS_CACHE_KEYS.bySlug(slug), locale.value]),
    placeholderData(data) {
      return data
    },
    queryFn: () => {
      return $orpc.restaurants.getBySlug({
        restaurantSlug: slug,
      })
    },
  })
}

export function useGetRestaurantBySearchQuery(query: MaybeRef<string>) {
  const { $orpc } = useNuxtApp()
  const { locale } = useI18n()

  return useQuery({
    queryKey: computed(() => [...RESTAURANTS_CACHE_KEYS.bySearchQuery(query), locale.value]),
    placeholderData(data) {
      return data
    },
    queryFn: () => {
      return $orpc.restaurants.searchManageable({
        query: unref(query),
      })
    },
  })
}

export function useGetRestaurantEvents(restaurantSlug: string) {
  const { $orpc } = useNuxtApp()

  return useQuery({
    queryKey: RESTAURANTS_CACHE_KEYS.events(restaurantSlug),
    queryFn: () => $orpc.restaurants.events.list({ restaurantSlug }),
  })
}
